import { Observable } from "rxjs";
import { BaseItemModel } from "@webapp/core/abstracts/models/base-item.model";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class BaseCache<T extends BaseItemModel> {
  [key: string]: BaseCacheItem<T>;
}
export class BaseCacheItem<T extends BaseItemModel> {
  public expires: Date;
  public value: Observable<T>;
}
